<ngx-ui-loader></ngx-ui-loader>
<p-toast [baseZIndex]="999999"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" rejectButtonStyleClass="p-button-text">
</p-confirmDialog>
<router-outlet></router-outlet>
<div id="divLoader" class="loader" style="display: none;">
</div>